import { render, staticRenderFns } from "./SVGPhotoAddNew.vue?vue&type=template&id=625c4c2a&scoped=true&"
import script from "./SVGPhotoAddNew.vue?vue&type=script&lang=js&"
export * from "./SVGPhotoAddNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625c4c2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('625c4c2a')) {
      api.createRecord('625c4c2a', component.options)
    } else {
      api.reload('625c4c2a', component.options)
    }
    module.hot.accept("./SVGPhotoAddNew.vue?vue&type=template&id=625c4c2a&scoped=true&", function () {
      api.rerender('625c4c2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGPhotoAddNew.vue"
export default component.exports